import React, { useState, useEffect } from "react"
import Spinner from "../Spinner"
import { Container, Button, Row } from "reactstrap"
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table"
import "./SuperResponsiveTableStyle.css"
import { Link } from "react-router-dom"
import axios from "axios"

const APIserver = "https://hdform.herokuapp.com/api/facility/"

const FacilityDetails = (props) => {
  const [data, setData] = useState([])
  const [visitorsData, setVisitorsData] = useState([])
  const [loading, setLoading] = useState(false)

  function getFacilityData() {
    setLoading(true)
    fetch(APIserver + props.match.params.id)
      .then((res) => res.json())
      .then((res) => {
        setData(res)
        setVisitorsData(res.visitors)
        setLoading(false)
      })
  }

  function deleteFacility() {
    setLoading(true)
    axios.delete(APIserver + "delete/" + data.id).then((res) => {
      console.log(res)
      setLoading(false)
    })
  }

  useEffect(() => {
    getFacilityData()
  }, [])

  const Details = () => {
    return (
      <div className="details-container">
        <p>Facility Name: {data.name}</p>
        <p>Mobile: {data.mobile}</p>
        <p>Address: {data.address}</p>
        <p>Facility Code: {data.code}</p>
        <strong>Total Visits: {data.totalVisitors}</strong>
        <div className="tbl-visitors">
          <h3>Visitors Log</h3>
          {visitorsData.length === 0 ? (
            <p>No data to show</p>
          ) : (
            <Table>
              <Thead>
                <Tr>
                  <Th>Visitor name</Th>
                  <Th>Gender</Th>
                  <Th>Age</Th>
                  <Th>Mobile</Th>
                  <Th>Has Symptoms</Th>
                  <Th>Has Travelled</Th>
                  <Th>Suspect</Th>
                  <Th>Address</Th>
                  <Th>Date of Visit</Th>
                </Tr>
              </Thead>
              <Tbody>
                {visitorsData.map((visitor, index) => (
                  <Tr>
                    <Td>{visitor.name}</Td>
                    <Td>{visitor.sex}</Td>
                    <Td>{visitor.age}</Td>
                    <Td>{visitor.mobile}</Td>
                    <Td>{visitor.has_symptoms}</Td>
                    <Td>{visitor.has_travelled}</Td>
                    <Td>{visitor.is_suspect}</Td>
                    <Td>{visitor.address}</Td>
                    <Td>{visitor.response_date}</Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          )}
        </div>
      </div>
    )
  }
  return (
    <Container className="details-padding-top">
      <div className="qr-page-back-btn">
        <Row className="container">
          <Link to="/admin">
            <Button color="secondary">Back</Button>
          </Link>
          <Link to={`/admin/facility/edit/${data.id}`}>
            <Button color="primary">Edit details</Button>
          </Link>
        </Row>
      </div>
      <div className="header-container">
        <h2>{data.name}</h2>
      </div>
      {loading === true ? <Spinner /> : <Details />}
    </Container>
  )
}

export default FacilityDetails
